/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';
angular.module('bulbApp.explorerModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule'])
.config(['$stateProvider', 'AUTH', function($stateProvider, AUTH) {
  $stateProvider
  .state('explore', {
    parent: 'root',
    url: '^/b/explore',
    resolve: {
      $title: ['$translate', ($translate) => $translate('explore_text')]
    },
    views: {
      'content@root': {
        templateUrl: 'ajs/explore/explore.html'
      }
    },
    bulbAuth: {
      authorizedRoles: [AUTH.ROLES.USER]
    }
  });
}]);
